import { ThemedButton } from '../../ThemedButton'
import AnimatedLoader from '../../AnimatedLoader'
import useWeb3 from '../../../hooks/useWeb3'
import useIsLoggedIn from '../../../hooks/useIsLoggedIn'

function ConnectWalletButton({
  label = 'Connect',
  w,
}: {
  label?: string
  w?: string
}) {
  const { isLoggedIn, isAuthenticating } = useIsLoggedIn()
  const { initWeb3 } = useWeb3()

  return (
    <ThemedButton $styleType="primary" onClick={initWeb3} type="button" w={w}>
      {isAuthenticating ? (
        <>
          <AnimatedLoader size={14} />
          <span>Connecting...</span>
        </>
      ) : isLoggedIn ? (
        <span>Connected</span>
      ) : (
        <span>{label}</span>
      )}
    </ThemedButton>
  )
}

export default ConnectWalletButton
